import gql from 'graphql-tag'

export default gql`query getPages {
  getPages {
		id
		type
		updated_at
		details {
			id
			title
			content
			language_code
      meta_title
      meta_description
      meta_tags
      meta_og_title
      meta_og_description
      meta_og_url
		}
	}
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/page/getPages.js